// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"g6-z","displaySixCardTiles":"h6-z"};